export const landingAdvantages = [
  {
    titleKey: "landing.advantages.items.styleLearning.title",
    descriptionKey: "landing.advantages.items.styleLearning.description",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="url(#theme-gradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="theme-gradient" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" style="stop-color: var(--theme-gradient-start)"/><stop offset="100%" style="stop-color: var(--theme-gradient-end)"/></linearGradient></defs><path d="M3 9a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"/><path d="M9 3h10a2 2 0 0 1 2 2v10"/><path d="m3 17 4-4 4 4"/><circle cx="12" cy="11" r="1.5"/></svg>',
  },
  {
    titleKey: "landing.advantages.items.gapVisualization.title",
    descriptionKey: "landing.advantages.items.gapVisualization.description",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="url(#theme-gradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="theme-gradient" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" style="stop-color: var(--theme-gradient-start)"/><stop offset="100%" style="stop-color: var(--theme-gradient-end)"/></linearGradient></defs><path d="M21.21 15.89A10 10 0 1 1 8 2.83"/><path d="M22 12A10 10 0 0 0 12 2v10z"/></svg>',
  },
  {
    titleKey: "landing.advantages.items.aiInsights.title",
    descriptionKey: "landing.advantages.items.aiInsights.description",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="url(#theme-gradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="theme-gradient" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" style="stop-color: var(--theme-gradient-start)"/><stop offset="100%" style="stop-color: var(--theme-gradient-end)"/></linearGradient></defs><path d="M2 14.5s3-5 8-5 8 5 8 5-3 5-8 5-8-5-8-5z"/><circle cx="10" cy="14.5" r="2"/><path d="M19 2a3 3 0 0 0 3 3 3 3 0 0 0-3 3 3 3 0 0 0-3-3 3 3 0 0 0 3-3z"/></svg>',
  },
  {
    titleKey: "landing.advantages.items.styleAdaptation.title",
    descriptionKey: "landing.advantages.items.styleAdaptation.description",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="url(#theme-gradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="theme-gradient" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" style="stop-color: var(--theme-gradient-start)"/><stop offset="100%" style="stop-color: var(--theme-gradient-end)"/></linearGradient></defs><path d="M6 4 L6 20 M12 4 L12 20 M18 4 L18 20"/><circle cx="6" cy="14" r="1.4" fill="url(#theme-gradient)"/><circle cx="12" cy="8" r="1.4" fill="url(#theme-gradient)"/><circle cx="18" cy="16" r="1.4" fill="url(#theme-gradient)"/></svg>',
  },
];

// Landing Page 版本 B（Advantages）独有文案数据源。
// 采用方案二「品类区隔型」文案，i18n key 使用独立的 landingB.advantagesB.* 命名空间，
// 不覆盖版本 A 的 landing.advantages.*（见方案 §8.2）。
// 条目顺序与四张配图（reference/gap/ai/apply）一一对应，请勿重排。
export const landingAdvantagesB = [
  {
    titleKey: "landingB.advantagesB.items.styleLearning.title",
    descriptionKey: "landingB.advantagesB.items.styleLearning.description",
  },
  {
    titleKey: "landingB.advantagesB.items.gapVisualization.title",
    descriptionKey: "landingB.advantagesB.items.gapVisualization.description",
  },
  {
    titleKey: "landingB.advantagesB.items.aiInsights.title",
    descriptionKey: "landingB.advantagesB.items.aiInsights.description",
  },
  {
    titleKey: "landingB.advantagesB.items.styleAdaptation.title",
    descriptionKey: "landingB.advantagesB.items.styleAdaptation.description",
  },
];

export const landingFeatures = [
  {
    key: "one_click",
    titleKey: "landing.features.items.learnStyle.title",
    descriptionKey: "landing.features.items.learnStyle.description",
    backgroundImage:
      "https://img.photoscope.cc/features/reference-style-learning.webp",
  },
  {
    key: "visualizations",
    titleKey: "landing.features.items.seeGaps.title",
    descriptionKey: "landing.features.items.seeGaps.description",
    backgroundImage:
      "https://img.photoscope.cc/features/style-gap-visualization.webp",
  },
  {
    key: "tonal",
    titleKey: "landing.features.items.aiAnalysis.title",
    descriptionKey: "landing.features.items.aiAnalysis.description",
    backgroundImage:
      "https://img.photoscope.cc/features/ai-style-explanation.webp",
  },
  {
    key: "color",
    titleKey: "landing.features.items.applyStyle.title",
    descriptionKey: "landing.features.items.applyStyle.description",
    backgroundImage:
      "https://img.photoscope.cc/features/apply-style-understanding.webp",
  },
];

export const landingUseCases = [
  {
    titleKey: "landing.useCases.items.beginners.title",
    descriptionKeys: [
      "landing.useCases.items.beginners.description.0",
      "landing.useCases.items.beginners.description.1",
      "landing.useCases.items.beginners.description.2",
    ],
    image: "/images/beginner.svg",
  },
  {
    titleKey: "landing.useCases.items.enthusiasts.title",
    descriptionKeys: [
      "landing.useCases.items.enthusiasts.description.0",
      "landing.useCases.items.enthusiasts.description.1",
      "landing.useCases.items.enthusiasts.description.2",
    ],
    image: "/images/enthusiasts.svg",
  },
  {
    titleKey: "landing.useCases.items.aesthetic.title",
    descriptionKeys: [
      "landing.useCases.items.aesthetic.description.0",
      "landing.useCases.items.aesthetic.description.1",
      "landing.useCases.items.aesthetic.description.2",
    ],
    image: "/images/aesthetic_seekers.svg",
  },
  {
    titleKey: "landing.useCases.items.practical.title",
    descriptionKeys: [
      "landing.useCases.items.practical.description.0",
      "landing.useCases.items.practical.description.1",
      "landing.useCases.items.practical.description.2",
    ],
    image: "/images/practical_photographers.svg",
  },
];

export const landingSteps = [
  {
    titleKey: "landing.steps.items.upload.title",
    descriptionKey: "landing.steps.items.upload.description",
  },
  {
    titleKey: "landing.steps.items.analyze.title",
    descriptionKey: "landing.steps.items.analyze.description",
  },
  {
    titleKey: "landing.steps.items.edit.title",
    descriptionKey: "landing.steps.items.edit.description",
  },
  {
    titleKey: "landing.steps.items.review.title",
    descriptionKey: "landing.steps.items.review.description",
  },
];

export const landingTestimonials = [
  {
    nameKey: "landing.testimonials.items.sarah.name",
    contentKey: "landing.testimonials.items.sarah.content",
  },
  {
    nameKey: "landing.testimonials.items.michael.name",
    contentKey: "landing.testimonials.items.michael.content",
  },
  {
    nameKey: "landing.testimonials.items.emma.name",
    contentKey: "landing.testimonials.items.emma.content",
  },
];
